// extracted by mini-css-extract-plugin
export default {"wrapper":"UpdateWorkProfileModal_wrapper__G-eyV","secondaryInput":"UpdateWorkProfileModal_secondaryInput__2Z1SG","semibold":"UpdateWorkProfileModal_semibold__HT4RD"};